import { BrowserModule } from '@angular/platform-browser';
import { AppComponent } from './app.component';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PageNotFoundComponent } from './shared/components/page-not-found/page-not-found.component';
import { Routing } from './app-routing.module';
import { MainLayoutModule } from './layouts/main-layout/main-layout.module';
import { AuthGuard } from './core/auth-guard/auth.guard';
import { AuthenticationService } from './core/authentication/authentication.service';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from '../environments/environment'; // Angular CLI environment
import { appReducers } from './store/app-state';
import { ToolbarService } from './shared/services/toolbar.service';
import { SocketService } from '@shared/services/socket.service';
import { NgxLinkifyjsModule } from 'ngx-linkifyjs';
import { DeviceDetectorService } from 'ngx-device-detector';


@NgModule({
  declarations: [AppComponent, PageNotFoundComponent],
  imports: [
    BrowserModule,
    Routing,
    MainLayoutModule,
    HttpClientModule,
    BrowserAnimationsModule,
    StoreModule.forRoot(appReducers),
    StoreDevtoolsModule.instrument({
      maxAge: 25, // Retains last 25 states
      logOnly: environment.production // Restrict extension to log-only mode
    }),
    NgxLinkifyjsModule.forRoot()
  ],
  providers: [AuthenticationService, AuthGuard, ToolbarService, SocketService, DeviceDetectorService],
  bootstrap: [AppComponent]
})
export class AppModule { }
